module.exports = __webpack_public_path__ + "img/icon-pedidos-white.1de2b9c3.svg";